import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  message:
    'You can now change the look of your invoice template and add customised information in {settings}.',
  settings: 'Settings',
})
